export default {
  base: {
    hideOn: [],
    alignment: {
    } /* default inherits */
  },
  styles: {
    desktop: {
      root: {
        default: {
          spacing: {
            padding: {
              top: 20,
              bottom: 20,
              left: 0,
              right: 0,
              unit: 'px'
            }
          }
        }
      }
    }
  }
}
